/**
 * L'OFFERTA DI DATACOM AI, IN UN POSTO SOLO (23/10/2026).
 *
 * Fino al 23/10 la stessa offerta si raccontava in nove modi («7 giorni di
 * valutazione», «lo attiva Datacom», «account gratuito», «3 mesi in
 * regalo»…). Davide ha scelto la proposta C: sette giorni completi, poi
 * l'account resta gratuito (3 domande a settimana sulle norme), e per i
 * manuali dei marchi c'e' la licenza. Le parole approvate stanno in
 * docs/offerta-unica/FRASARIO.md; qui ci sono i numeri e le frasi che usano
 * l'app e le funzioni del server.
 *
 * COPIA IDENTICA in supabase/functions/_shared/offerta.ts (src/lib/offerta.test.ts
 * confronta i due file): niente import, niente API di Deno o del browser.
 *
 * Sull'iPhone non si usa niente di quello che parla di prova, licenza o
 * Datacom che attiva (Apple 3.1.1): li' resta solo TESSERA_GRATUITA.
 */

/** I numeri, scritti una volta sola. */
export const PROVA_GIORNI = 7;
export const PROVA_DOMANDE = 100;
export const GRATUITO_DOMANDE_SETTIMANA = 3;
export const LICENZA_DOMANDE_SETTIMANA = 100;
/** Il regalo del negozio: mesi di licenza al primo ordine sopra la soglia (IVA esclusa). */
export const REGALO_MESI = 3;
export const REGALO_SOGLIA_EURO = 300;

/** Fuori dall'app iPhone: la formula unica e le sue parti. */
export const OFFERTA = {
  corta: `Prova gratis ${PROVA_GIORNI} giorni, senza carta di credito.`,
  prova: `Provi tutto gratis per ${PROVA_GIORNI} giorni, senza carta di credito.`,
  dopo:
    `Poi l'account resta gratuito, con gli strumenti di calcolo e ${GRATUITO_DOMANDE_SETTIMANA} domande a ` +
    "settimana sulle norme. Per i manuali dei marchi c'è la licenza.",
  comeLicenza: "La licenza si attiva dal sito ai.datacomtecnologie.it o tramite Datacom.",
  clienti: "Sei già cliente Datacom? Chiedi il periodo gratuito riservato ai clienti.",
  regalo: `Al primo ordine sopra ${REGALO_SOGLIA_EURO} € + IVA, ${REGALO_MESI} mesi di licenza Datacom AI in regalo.`,
} as const;

/** La formula lunga: prova + dopo. */
export const OFFERTA_LUNGA = `${OFFERTA.prova} ${OFFERTA.dopo}`;

/** Alla fine della prova (sito e Android). */
export const FINE_PROVA = {
  titolo: "La prova completa è finita",
  testo:
    `Il tuo account resta gratuito: strumenti di calcolo e ${GRATUITO_DOMANDE_SETTIMANA} domande a settimana ` +
    "sulle norme. Per i manuali dei marchi e la dichiarazione di conformità c'è la licenza: si attiva dal sito " +
    "ai.datacomtecnologie.it o tramite Datacom.",
  tasto: "Attiva la licenza",
} as const;

/** L'account gratuito: e' l'unica frase che vale anche sull'iPhone. */
export const TESSERA_GRATUITA = {
  titolo: "Account gratuito",
  dettaglio: `Strumenti di calcolo e ${GRATUITO_DOMANDE_SETTIMANA} domande a settimana sulle norme`,
} as const;

/** I messaggi del server. */
export const MESSAGGI = {
  serveAccount: `Per usare l'assistente serve un account. ${OFFERTA.prova}`,
  serveAccountIphone: "Per usare l'assistente accedi con il tuo account.",
  quotaGratuito: `Hai usato le ${GRATUITO_DOMANDE_SETTIMANA} domande di questa settimana sulle norme: il conteggio riparte lunedì.`,
  quotaProva:
    `Hai usato le ${PROVA_DOMANDE} domande della prova gratuita. Finiti i ${PROVA_GIORNI} giorni l'account resta ` +
    `gratuito, con ${GRATUITO_DOMANDE_SETTIMANA} domande a settimana sulle norme. Per i manuali dei marchi c'è la licenza.`,
} as const;
